import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

import { setAppId } from '../slices/app';

export default (appId: EvidencePlatformSidebarAppID) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setAppId(appId));
  }, [dispatch, appId]);
};
